import { render } from "./BaseWordLoading.vue?vue&type=template&id=0e7a69e3&scoped=true&ts=true"
import script from "./BaseWordLoading.vue?vue&type=script&lang=ts"
export * from "./BaseWordLoading.vue?vue&type=script&lang=ts"

import "./BaseWordLoading.vue?vue&type=style&index=0&id=0e7a69e3&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7a69e3"]])

export default __exports__